export function parseTime(time) {
  const parts = time.split(':');

  const hours = parseInt(parts[parts.length - 3], 10) || 0;
  const minutes = parseInt(parts[parts.length - 2], 10) || 0;
  const seconds = parseFloat(parts[parts.length - 1]) || 0;

  return hours * 3600 + minutes * 60 + seconds;
}

function toTwoDigits(value) {
  return String(value).padStart(2, '0');
}

export function formatTimeWholeSeconds(value) {
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const seconds = Math.floor(value % 60);
  return `${toTwoDigits(hours)}:${toTwoDigits(minutes)}:${toTwoDigits(seconds)}`;
}

export function formatTime(value) {
  const hundredths = Math.floor((value % 1) * 100);
  return `${formatTimeWholeSeconds(value)}.${toTwoDigits(hundredths)}`;
}
